import { types } from '../types/types';
import { getUserPermissions, processUserPermissions } from '@apis/mantenedores';

export const loadPermissions = (currentUser) => async (dispatch) => {
  dispatch({ type: types.PERMISSIONS_LOADING });
  try {
    const response = await getUserPermissions(currentUser);
    if (response.success) {
      const processed = processUserPermissions(response.data);
      dispatch({ type: types.PERMISSIONS_SUCCESS, payload: processed });
    } else {
      dispatch({ type: types.PERMISSIONS_ERROR, payload: response.error });
    }
  } catch (err) {
    dispatch({ type: types.PERMISSIONS_ERROR, payload: err.message });
  }
};

export const clearPermissions = () => ({ type: types.PERMISSIONS_CLEAR });
